import React from 'react';
import { DefaultModalProps, withLocationStateModal } from 'utils/modals';

import { Button, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { DefaultModal } from '@libs/ui/components/modals';

import { OpenJobsModals } from './types';

// Define props interface extending DefaultModalProps
interface ReportPreparingModalProps extends DefaultModalProps<void> {
  // No additional props needed for this modal
}

const useStyles = makeStyles((theme) => ({
  modal: {
    maxWidth: '400px',
  },
}));

// Create the modal component implementation
const ReportPreparingModalComponent = ({
  close,
  isOpen,
}: ReportPreparingModalProps) => {
  const classes = useStyles();
  return (
    <DefaultModal
      open={isOpen}
      className={classes.modal}
      handleClose={close}
      title="Preparing Your Report"
      actions={
        <Grid container>
          <Grid item xs={12}>
            <Button fullWidth color="info" variant="contained" onClick={close}>
              BACK TO DASHBOARD
            </Button>
          </Grid>
        </Grid>
      }
    >
      <Typography variant="body1" align="center" sx={{ mt: 8 }}>
        Your report is being generated and may take a few minutes to complete.
        It will be delivered to your email shortly.
      </Typography>
    </DefaultModal>
  );
};

// Export wrapped component with HOC
export const ReportPreparingModal = withLocationStateModal<void>({
  id: OpenJobsModals.REPORT_PREPARING,
})(ReportPreparingModalComponent);
